import { useIntl } from 'react-intl';
import messages from '../locales/messages';
import './InstanaROI.scss';
import { PDFBVAResultsProps, PDFGenerate } from './PDFGenerate';
import { ReactElement, useEffect, useState } from 'react';
import 'src/common/style/common.scss';
import { ThanksModal, thanksTable } from 'src/common/utils/ThanksModal';

export interface ThanksProps {
  disruptions: number;
  preventions: number;
  speedGain: number;
  avgTime: string;
  itOpsEmployees: number;
  developers: number;
  developerEffiencyGains: string;
  itOpsEffiencyGains: string;
  openSourceGains: string;
  totalEffiencyGains: string;
  openSourceTechnoList: string;
  resultsImage?: string;
  summaryImage?: string;
  isPdf: boolean;
  pdfObject?: JSX.Element;
  pdfExport: boolean;
}

const Thanks = ({
  disruptions,
  preventions,
  speedGain,
  avgTime,
  itOpsEmployees,
  developers,
  developerEffiencyGains,
  itOpsEffiencyGains,
  openSourceGains,
  totalEffiencyGains,
  openSourceTechnoList,
  resultsImage,
  summaryImage,
  isPdf,
  pdfExport,
}: ThanksProps): ReactElement => {
  const intl = useIntl();
  const props: PDFBVAResultsProps = {
    imgResults: resultsImage ? resultsImage : '',
    imgSummary: summaryImage ? summaryImage : '',
    pdfPara1: intl.formatMessage(messages.pdfPara1),
    pdfPara2: intl.formatMessage(messages.pdfPara2),
    pdfPara3: intl.formatMessage(messages.pdfPara3),
    pdfPara4: intl.formatMessage(messages.pdfPara4),
    pdfPara5: intl.formatMessage(messages.pdfPara5),
    pdfPara6: intl.formatMessage(messages.pdfPara6),
    pdfPara7: intl.formatMessage(messages.pdfPara7),
    heading: intl.formatMessage(messages.page_heading_3),
  };
  let pdfContentThanks: thanksTable[] = [];
  const pdfObject = PDFGenerate(props);
  const [showThanksModal, setShowThanksModal] = useState(true);
  const titleThanks: thanksTable[] = [
    {
      group: 'title',
      value: String(intl.formatMessage(messages['thankyou.title'])),
    },
    {
      group: 'subTitle',
      value: String(intl.formatMessage(messages['thankyou.subtitle'])),
    },
  ];
  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: String(intl.formatMessage(messages['thankyou.details-title'])),
    },
  ];
  const contentThanks: thanksTable[] = [
    {
      group: String(intl.formatMessage(messages['chart_label_summary_1'])),
      value: String(disruptions),
    },
    {
      group: String(intl.formatMessage(messages['chart_label_summary_2'])),
      value: String(avgTime),
    },
    {
      group: String(intl.formatMessage(messages['chart_label_summary_3'])),
      value: String(developers),
    },
    {
      group: String(intl.formatMessage(messages['chart_label_summary_4'])),
      value: String(itOpsEmployees),
    },
    {
      group: String(intl.formatMessage(messages['chart_label_summary_5'])),
      value: String(openSourceTechnoList),
    },
    {
      group: String(intl.formatMessage(messages['label_1'])),
      value: String(preventions),
    },
    {
      group: String(intl.formatMessage(messages['label_2'])),
      value: String(speedGain),
    },
    {
      group: String(intl.formatMessage(messages['label_3'])),
      value: String(developerEffiencyGains),
    },
    {
      group: String(intl.formatMessage(messages['label_4'])),
      value: String(itOpsEffiencyGains),
    },
    {
      group: String(intl.formatMessage(messages['label_6'])),
      value: String(openSourceGains),
    },
    {
      group: String(intl.formatMessage(messages['page_heading_total'])),
      value: String(totalEffiencyGains),
    },
  ];
  const buttonThanks: thanksTable[] = [
    {
      group: 'button1',
      value: String(intl.formatMessage(messages['return-to-estimator'])),
    },
  ];
  {
    pdfExport &&
      (pdfContentThanks = [
        {
          group: String(intl.formatMessage(messages['downloadText'])),
          value: `instana_bva_${new Date()}.pdf`,
        },
      ]);
  }
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    setShowModal(true);
  }, [
    disruptions,
    preventions,
    speedGain,
    avgTime,
    itOpsEmployees,
    developers,
    developerEffiencyGains,
    itOpsEffiencyGains,
    openSourceGains,
    totalEffiencyGains,
    openSourceTechnoList,
    resultsImage,
    summaryImage,
    isPdf,
    pdfExport,
  ]);
  return (
    <ThanksModal
      showThanksModal={showModal}
      pageTitle="Instana ROI Page"
      object="Instana ROI Page"
      productTitle={'Instana ROI'}
      pageUrl={''}
      location={'Instana ROI Estimator'}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      buttonThanks={buttonThanks}
      pdfExport={pdfExport}
      {...(pdfExport && pdfObject && { pdfArray: pdfContentThanks })}
      {...(pdfExport && pdfObject && { pdfObject: pdfObject })}
      setShowThanksModal={setShowThanksModal}
    ></ThanksModal>
  );
};

export default Thanks;
